var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEDetailManager(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-1458 -1023)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 32,
    height: 32,
    transform: "translate(1458 1023)",
    fill: "rgba(242,242,242,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11101",
    "data-name": "Group 11101",
    transform: "translate(12884 9191)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2335",
    "data-name": "Rectangle 2335",
    width: 19.998,
    height: 16.362,
    rx: 3,
    transform: "translate(-11420 -8160)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("g", {
    id: "activity",
    transform: "translate(-11416.35 -8155.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6767",
    "data-name": "Path 6767",
    d: "M10.163,11.145a.486.486,0,0,0,.417-.195l2.154-3.565H14.7V6.759H12.43a.486.486,0,0,0-.417.195l-1.85,3.026L6.508,3.2A.48.48,0,0,0,6.081,3a.469.469,0,0,0-.422.213L3.941,6.758H2v.626H4.267A.473.473,0,0,0,4.7,7.171L6.081,4.253,9.737,10.94A.48.48,0,0,0,10.163,11.145Z",
    transform: "translate(-2 -2.999)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEDetailManager);
export default __webpack_public_path__ + "static/media/E-Detail_Manager.8a4076c0b4f6d8bc2290c1d988ea7b72.svg";
export { ForwardRef as ReactComponent };